export const facetTrimingCatalogValidator = {
    isFacetTrimingCatalog: (code: string): boolean => {
        const reactAppFacetTrimingCatalog = process.env.REACT_APP_FACET_TRIMING_CATALOG;
        let isFacetTrimingCatalog = false;

        if (reactAppFacetTrimingCatalog && reactAppFacetTrimingCatalog.trim() !== '') {
            const splittedReactAppFacetTrimingCatalog = reactAppFacetTrimingCatalog.split(',');

            if (splittedReactAppFacetTrimingCatalog.length > 0) {
                isFacetTrimingCatalog = splittedReactAppFacetTrimingCatalog.some((catalog: string) =>
                    code.includes(catalog)
                );
            }
        }

        return isFacetTrimingCatalog;
    }
}

// Utility to check if any category matches any item in the facet trimming catalog
export function isFacetTrimingCatalogMatch(categories: string[], facetTrimingCatalog: string): boolean {
    if (!facetTrimingCatalog || facetTrimingCatalog.trim() === '') return false;
    const facetTrimingCatalogVariable = facetTrimingCatalog.split(',');
    if (!facetTrimingCatalogVariable || facetTrimingCatalogVariable.length === 0) return false;
    return categories.some((category: string) =>
        facetTrimingCatalogVariable.some((item: string) => category.includes(item))
    );
}